import { createFileRoute, redirect } from '@tanstack/react-router'

import { isOidcEnabled } from "@/lib/auth/oidc-bootstrap";
import { ForgotPasswordForm } from "@/modules/login/components/forgot-password-form";

export const Route = createFileRoute('/forgot-password')({
  beforeLoad: (): void => {
    // Keycloak owns credentials after the cutover: this page would reset a password nobody can
    // use, so it collapses into the /login shim.
    if (isOidcEnabled()) {
      throw redirect({'to': '/login'})
    }
  },

  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[#022D4F]">
      <ForgotPasswordForm />
    </div>
  )
}
